<template>
    <div>
    <v-row>
        <v-container fluid>
        <v-card class="scholarship">
                <v-row justify="center" no-gutters>
                    <v-col cols="11" class="no-row-padding">
                        <v-row justify="space-between" no-gutters>
                            <div cols="11" class="no-row-padding">
                                <div class="scholarship-status" :style="statusStyle(detail)">{{`${applicationStatus(detail).toUpperCase()}`}}</div>
                                <div class="scholarship-title">{{ `${detail.Name.split('|')[0].toUpperCase()}` }}<a :href="detail.Website__c" target="_blank"><InfoIcon class="more"></InfoIcon></a></div>
                                <div class="scholarship-title" v-if="showschool()">{{ `${schoolname.toUpperCase()}` }}</div>
                            </div>
                            <div v-if="showlogo" style="position: relative;height: 100%;min-width: 250px;min-height: 70px; margin-bottom: 10px;">
                                <!-- <img class="scholarship-logo" :src="`/PEF_logo@2x.png`"> SchoolLogo 123123 -->
                                <!-- <img class="scholarship-logo" :src="SchoolLogo()" style="max-width:250px;max-height:100px;top:30px;max-height:100px"> -->
                                <!-- <img class="scholarship-logo" :src="detail.Scholarship_Application__c.School__r.logo" style="max-width:250px;max-height:100px;top:30px;max-height:100px">  -->
                                <img class="scholarship-logo" :src="logoString" style="max-width:250px;max-height:100px;top:30px;">
                            </div>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row justify="center" no-gutters style="margin-top: 10px">
                    <v-col cols="11"><span class="scholarship-content" v-html="detail.Description__c"></span></v-col>
                </v-row>
                <v-row justify="center" no-gutters>
                    <v-col cols="11">
                        <v-row justify="space-between">
                            <v-col cols="12" sm="6" md="3" lg="3">
                                <div class="scholarship-content"><b>Inclusions</b></div>
                                <span class="scholarship-content" v-html="detail.Inclusions__c"></span>
                            </v-col>
                            
                            <v-col cols="12" sm="6" md="3" lg="3">
                                <div class="scholarship-content"><b>Who is eligible?</b></div>
                                <span class="scholarship-content" v-html="detail.Who_is_eligible__c"></span>
                            </v-col>
                            
                            <v-col cols="12" sm="6" md="3" lg="3">
                                <div class="scholarship-content"><b>Length of scholarship</b></div>
                                <!--
                                <span class="scholarship-content">{{detail.Length_of_Scholarship__c}}</span>
                                -->
                                
                                <span class="scholarship-content">{{showLengthofScholarship()}}</span>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="3">
                                <div class="scholarship-content"><b>Applications close</b></div>
                                <p class="scholarship-content">{{ApplicationCloseDate}}</p>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row justify="center" style="height: 113px" no-gutters>
                    <v-col cols="11" v-if="applicationButtonType(detail) == 1">
                        <button v-if="!creating" @click="onButtonClicked(detail)" class="apply-button apply-button-text">{{`${applicationButtonText(detail).toUpperCase()}`}}</button>
                        <button v-else class="apply-button"><span class="spin">&bull;</span></button>
                    </v-col>
                    <v-col cols="11" v-if="applicationButtonType(detail) == 2">
                        <div class="application-submitted-text"><b>{{`${applicationButtonText(detail)}`}}</b></div>
                    </v-col>
                </v-row>   
        </v-card>
        </v-container>
    </v-row>
    <v-dialog persistent v-model="showConfirm" class="mx-auto" max-width="410">
        <v-card class="dialog-style dialog-margin">
            <div class="tips">
                Hello! Thanks for being a Community Referee. In your reference, please tell us why you support (or don’t support) this student’s application.
                <br><br>
                We are NOT looking for your endorsement of their Aboriginality or Torres Strait Islander heritage.
            </div>
            <v-card-actions class="margin">
                <v-btn large text class="popup-button leave-button" @click="beginApplication(detail)"><span class="go-back">CONTINUE</span></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    </div>
</template>
<script>
import axios from 'axios';
import Client from '../client.js';
import InfoIcon from '../../public/system_info.svg';
/*
import school_ascham from "../../public/school_ascham.jpg";
import school_barker from "../../public/school_barker.jpg";
//import school_gawura from "../../public/school_gawura.jpg";
import school_knox from "../../public/school_knox.jpg";
//import school_pymbleladiescollege from "../../public/school_pymbleladiescollege.jpg";

import school_stcatherines from "../../public/school_stcatherines.jpg";
import school_stgregorys from "../../public/school_stgregorys.jpg";
import school_waverley from "../../public/school_waverley.jpg";

import school_stscholasticas from "../../public/school_stscholasticas-glebe.jpg";
import school_immanuel from "../../public/school_immanuel-adelaide.jpg";
import school_meriden from "../../public/school_meriden.jpg";
import school_standrews from "../../public/school_standrews.jpg";
*/
import Pef_logo from "../../public/PEF_logo@2x.png";

const STATUS_COLOR = {
    undefined: '#9a9a9a',
    'Not started': '#9a9a9a',
    'Reference requested': '#9a9a9a',
    'In Progress': '#ea7f1d',
    'Submitted & Under Review': '#d05927',
    'Submitted & Reviewed': '#d05927',
    'Preliminary Review': '#d05927',
    'Committee Review': '#d05927',
    'Successful': '#d05927',
    'Unsuccessful': '#d05927',
    'Incompleted': '#d05927'
}

const BUTTON_TEXT = {
    undefined: 'Start Application',
    'Not started': 'Start Application',
    'Reference requested': 'Start Reference',
    'In Progress': 'Continue Application',
    'Submitted & Under Review': 'This scholarship is under review. Until then, we are unable to give you further information on the status of your application.',
    'Submitted & Reviewed': 'This scholarship is under review. Until then, we are unable to give you further information on the status of your application.',
    'Preliminary Review': 'This scholarship is under review. Until then, we are unable to give you further information on the status of your application.',
    'Committee Review': 'This scholarship is under review. Until then, we are unable to give you further information on the status of your application.',
    'Successful': 'This scholarship is under review. Until then, we are unable to give you further information on the status of your application.',
    'Unsuccessful': 'This scholarship is under review. Until then, we are unable to give you further information on the status of your application.',
    'Incompleted': 'This scholarship is under review. Until then, we are unable to give you further information on the status of your application.'
}

const BUTTON_TYPE = {
    undefined: 1,
    'Not started': 1,
    'Reference requested': 1,
    'In Progress': 1,
    'Submitted & Under Review': 2,
    'Submitted & Reviewed': 2,
    'Preliminary Review': 2,
    'Committee Review': 2,
    'Successful': 2,
    'Unsuccessful': 2,
    'Incompleted': 2
}

const ACTION_TYPE = {
    undefined: 1,
    'Not started': 1,
    'In Progress': 2,
    'Reference requested': 3
}

const MONTH_MAPPING = {
    '01': 'January',
    '02': 'February',
    '03': 'March',
    '04': 'April',
    '05': 'May',
    '06': 'June',
    '07': 'July',
    '08': 'August',
    '09': 'September',
    '10': 'October',
    '11': 'November',
    '12': 'December'
}

export default {
    components:{
        InfoIcon,
    },
    props:{
        detail: Object,
        goToReference: Function,
        type: String,
    },
    data: function() {
        return {
            creating: false,
            showConfirm: false,
            schoolname: "",
            schoolid: "",
            logoString: "",
            showlogo: false,
        }
    },
    async beforeMount() {
        //await this.$store.dispatch('school/fetchSchoolLogo');
        //this.$store.getters['school/schoollogo'];
        
        //this.newSchool = requests[2].data.school_id[0].school_id;
        //this.schoolid =  requests[0].data.school_id[0].school_id;
        //this.$store.commit('schtype/updateData',{key: 'scholarshiptype', data: 'public'});
        //this.logoString =  this.SchoolLogo();


        //next 2 neeed to run sequencely
        //await this.$store.dispatch('school/fetchSchoolLogo');
        //setTimeout(this.SchoolLogo(), 2000);
        
        /*
        await new Promise((resolve) => {
                    setTimeout(() => {
                        this.$store.commit('school/updateSchoolLogo', requests[0].data.school_id[0].school_id);
                        this.$store.dispatch('school/fetchSchoolLogo');
                        resolve();
                    }, 1000)
                }).then(()=>{
                    console.log('then');
                    this.SchoolLogo()})
                .catch(error=>{
                    console.log('error');
                    console.log(error);
                });
        console.log('finish before mount 111');
        */
       this.SchoolLogo();
    },
    methods: {
        onButtonClicked(scholarship) {
            if(ACTION_TYPE[scholarship['Scholarship_Application__c.Status__c']] === 3 && this.type === 'community' && !this.showConfirm) {
                this.showConfirm = true;
                return;
            }
            this.beginApplication(scholarship);
        },
        async beginApplication(scholarship){

            this.creating = true;
            let applicationId = '';

            if(ACTION_TYPE[scholarship['Scholarship_Application__c.Status__c']] === 3){
                this.goToReference();
                return;
            }

            if(ACTION_TYPE[scholarship['Scholarship_Application__c.Status__c']] === 1){
                try { 
                    let client = Client();
                    let res = await axios.all([
                        client.post('applications', {scholarship_id: scholarship.Id, scholarship_name: scholarship.Name})
                    ]);
                    if(res[0].status === 200){
                        applicationId = res[0].data.salesforce_id
                    }
                } catch(e){
                    console.log(e)
                    this.creating = false;
                    return;
                }     
            } else {
                applicationId = scholarship['Scholarship_Application__c.Id']
            }
            console.log(applicationId)

            this.$router.push({
                name: "application.dashboard",
                params: {
                    application_id: applicationId
                }
            });
        },

        applicationButtonType(scholarship){
            return BUTTON_TYPE[scholarship['Scholarship_Application__c.Status__c']]
        },
        applicationStatus(scholarship){
            const status = scholarship['Scholarship_Application__c.Status__c'];
            if(!status) return 'Not Started';
            switch(status) {
                case 'In Progress':
                return status;
                case 'Submitted & Under Review':
                case 'Submitted & Reviewed':
                case 'Preliminary Review':
                case 'Committee Review':
                return 'Submitted' + ' - ' + this.ApplicationSubmittedDate;
                case 'Successful':
                return status;
                case 'Unsuccessful':
                case 'Incompleted':
                return 'Unsuccessful';
                default:
                return status;
            }
            // return !scholarship['Scholarship_Application__c.Status__c'] ? 'Not Started' : scholarship['Scholarship_Application__c.Status__c'] == 'Submitted & Under Review' ? `${scholarship['Scholarship_Application__c.Status__c']} - ${this.ApplicationSubmittedDate}` : scholarship['Scholarship_Application__c.Status__c'];
        },
        applicationButtonText(scholarship) {
            const reference = this.$store.getters['reference/reference'];
            if(reference && reference['Type__c'] === 'Primary Guardian' && scholarship['Scholarship_Application__c.Status__c'] === 'Reference requested') {
                this.$store.commit('schtype/updateData',{key: 'schoolname', data: reference['School__c']});
                console.log('update schoolname to store' + reference['School__c']);
                if(this.detail){
                    this.$store.commit('schtype/updateData',{key: 'scholarshiptype', data: this.detail.Type__c});
                    console.log('update scholarshiptype to store' + this.detail.Type__c);
                }
                return 'START DECLARATION'
            }
            return BUTTON_TEXT[scholarship['Scholarship_Application__c.Status__c']];
        },
        statusStyle(scholarship){
            return{
                '--status-color': STATUS_COLOR[scholarship['Scholarship_Application__c.Status__c']]
            }
        },
        SchoolLogo(){
            /*
            const reference = this.$store.getters['reference/reference'];
            console.log('scholarship component detail');
            console.log(this.detail);
            console.log('scholarship component detail app');
            //console.log(this.detail['Scholarship_Application__c']);
            console.log('scholarship component detail school logo');
            console.log(this.detail['Scholarship_Application__c.School__r.logo']);
            //console.log(this.detail.Scholarship_Application__c.School__r.logo);
            let schoolname = '';
            this.$store.commit('schtype/updateData',{key: 'scholarshiptype', data: this.detail.Type__c});
            schoolname = this.$store.getters['schtype/getschtype']['schoolname'];
            console.log('scholarshiptype / schoolname from store ');
            console.log(schoolname);
            if(this.detail.Type__c.toLowerCase() == 'public'){
                return Pef_logo;
            }else if(this.detail.Type__c.toLowerCase() == 'independent'){
                if(reference.School__c){
                    return this.getschoollogos(reference.School__c);
                }else if(schoolname){
                    return this.getschoollogos(schoolname);
                }else{
                    return this.getschoollogos(this.detail.Name);
                }
            }
            */
            
            const reference = this.$store.getters['reference/reference'];
            console.log('scholarship component detail');
            console.log(this.detail);
            this.$store.commit('schtype/updateData',{key: 'scholarshiptype', data: this.detail.Type__c});
            //let schoolname = '';123
            //schoolname = this.$store.getters['schtype/getschtype']['schoolname'];
            if(this.detail.Type__c.toLowerCase() == 'public'){
                this.logoString = Pef_logo;
            }else if(this.detail.Type__c.toLowerCase() == 'independent'){
                console.log('into independent judge');
                if(this.detail && this.detail['Scholarship_Application__c.School__r.logo']){
                    console.log('Into Detail pic');
                    this.logoString = this.detail['Scholarship_Application__c.School__r.logo'];
                }else if(reference.School__c){
                    console.log('Into Ref pic');
                    //this.schoolid = this.$store.getters['reference/reference'][]
                    this.logoString = this.$store.getters['reference/reference']['logo'];
                }else{
                    console.log('Into before app pic');
                    
                    
                    this.pullschoollogo();
                    //this.logoString = this.$store.getters['school']['schoollogo'];
                }
            }

        },
        showLengthofScholarship(){
            //detail.Length_of_Scholarship__c  aa
            if(this.detail.Type__c.toLowerCase() == 'independent'){
                return this.detail.Length_of_Scholarship__c;
            }else if(this.detail.Type__c.toLowerCase() == 'public'){
                return this.detail.Length_of_Scholarship__c;
            }
        },
        showschool(){
            console.log('SchoolName000');
            if(this.detail.Name.split('|')[1]){
                console.log('SchoolName111');
                this.schoolname = this.detail.Name.split('|')[1];
                return true;
            }else if(this.$store.getters['reference/reference'].School__c){
                console.log('SchoolName222');
                this.schoolname = this.$store.getters['reference/reference'].School__c;
                return true;
            }else if(this.$store.getters['schtype/getschtype']['schoolname']){
                console.log('SchoolName333');
                this.schoolname = this.$store.getters['schtype/getschtype']['schoolname'];
                return true;
            }else if(this.detail.intendedSchoolName){
                console.log('SchoolName444');
                this.schoolname = this.detail.intendedSchoolName;
                return true;
            }
            return false;
        },
        /*
        getschoollogos(schname){
            if(schname.toUpperCase() == 'ASCHAM TEST PICTURE SCHOOL'){
                return school_ascham;
            }else if(schname.toLowerCase().includes('ascham')){
                return school_ascham;
            }else if(schname.toLowerCase().includes('barker')){
                return school_barker;
            }else if(schname.toLowerCase().includes('immanuel')){
                return school_immanuel;
            }else if(schname.toLowerCase().includes('knox grammar')){
                return school_knox;
            }else if(schname.toLowerCase().includes('meriden')){
                return school_meriden;
            }else if(schname.toLowerCase().includes('st scholastica’s')){
                return school_stscholasticas;
            }else if(schname.toLowerCase().includes('st andrew’s cathedral')){
                return school_standrews;
            }else if(schname.toLowerCase().includes('st catherine’s')){
                return school_stcatherines;
            }else if(schname.toLowerCase().includes('st gregory’s')){
                return school_stgregorys;
            }else if(schname.toLowerCase().includes('waverley')){
                return school_waverley;
            }else{
                return '';
            }
        },
        */
        pullSchools(url, token) {
            
            return axios.get( url,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                }
            )
        },
        async pullschoollogo(){
            try {
                    let client = Client();
                        let requests = await axios.all([
                            client.get('me/new_schools')
                    ]);
                    this.schoolid =  requests[0].data.school_id[0].school_id;
                    console.log('before call api ' + this.schoolid);
                    let logoString2 = '/api/schools?logo=' + this.schoolid;
                    const res = await this.pullSchools(logoString2, this.$store.getters['user/token'])
                    //const res = await pullSchools(`/api/schools?active=0`, rootGetters['user/token'])

                    if(res.status === 200) {
                        //commit('updateSchoolLogoString', res.data);
                        this.logoString = res.data;
                        console.log('fetch logo finish');
                    }
                } catch(e) {
                    console.log(e);
                }
        },
    },
    computed: { 
        ApplicationCloseDate() {

            if(this.detail.Type__c.toLowerCase() == 'independent'){
                return 'No Closing Date';
            }else if(this.detail.Type__c.toLowerCase() == 'public'){
                const dateYMD = this.detail.Application_close_date__c.split('-')
                return `${dateYMD[2]} ${MONTH_MAPPING[dateYMD[1]]} ${dateYMD[0]}`
            }else{
                const dateYMD = this.detail.Application_close_date__c.split('-')
                return `${dateYMD[2]} ${MONTH_MAPPING[dateYMD[1]]} ${dateYMD[0]}`
            }
            
            
        },
        ApplicationSubmittedDate() {

            if(this.detail['Scholarship_Application__c.Submitted_Date__c']){
                const dateYMD = this.detail['Scholarship_Application__c.Submitted_Date__c'].split('-')
                return `${dateYMD[2]} ${MONTH_MAPPING[dateYMD[1]]} ${dateYMD[0]}`
            }
            return ''
        } 
    },
    watch: {
        logoString: function() {
            if(this.logoString && this.logoString.length > 0){
                this.showlogo = true;
            }else{
                this.showlogo = false;
            }
            this.$forceUpdate();
        },
    },
}
</script>
<style lang="scss" scoped>
.primary-font{
    font-family: Hind;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: black;
}

.secondary-font{
    font-family: Dosis;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: black;
}

.tertiary-font{
    font-family: Poppins;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: black;  
}


.scholarship {
  width: 100%;
  border: solid 1px #a4a4a4;
  background-color: #ffffff;
  margin: auto;
  padding: 0;
}

.scholarship-logo
{
    max-height: 53px;
    position: absolute;
    bottom: -10px;
    right:0;
}

.scholarship-content
{
    @extend .primary-font;
    font-size: 14px;
}

.scholarship-content p
{
    margin-bottom: 0;
}

.scholarship-title
{
    @extend .secondary-font;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 2.18px;
    margin-top: 10px;
}

.scholarship-status
{
    @extend .tertiary-font;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.75px;
    color:var(--status-color);
    margin-top: 30px;
}

.scholarship-criteria {
  width: 316px;
  height: 31px;
  @extend .secondary-font;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 3.2px;
  margin-top: 30px;
}

.scholarship-criteria-shape
{
    height: 75px;
    margin-bottom: 10px;
}

.scholarship-criteria-text
{
    @extend .primary-font;
    font-size: 14px;
}

.apply-button {
    width: 100%;
    height: 53px;
    border-radius: 3px;
    background-color: #ea7f1d;
    margin-top: 30px;

}

.apply-button-text
{
    @extend .tertiary-font;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1px;
    text-align: center;
    color: #ffffff;
}

.application-submitted-text
{
    @extend .primary-font;
    font-size: 16px;
    color: #b11116;
    width: 100%;
    height: 53px;
    text-align: left;
    margin-top: 40px;
}

.spin {
    color: white;
    display: flex;
    justify-content: center;
    -webkit-animation: dotting 2s infinite;
    -o-animation: dotting 2s infinite;
    animation: dotting 2s infinite;
}

.more {
    width: 25px;
    height: 25px;
    cursor: pointer;
    margin: 0px 0 -4px 10px;
}

@keyframes dotting {
    0% {
        text-shadow: 0 0 0 currentColor;
    }
    33% {
        text-shadow: -20px 0 0 currentColor;
    }
    66% {
        text-shadow: -20px 0 0 black, 20px 0 0 currentColor;
    }
    100% {
        text-shadow: 0px 0 0 currentColor;
    }
}
.dialog-style{
    width: 408px;
}
.tips{
    padding: 40px 38px 20px 30px;
    width: 408px;
    font-family: Hind;
}
.popup-button{
  width: 160px;
  height: 53px;
  border-radius: 3px;
  margin: 0 auto 0px auto;
  color: white;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1px;
  text-align: center;
}
.leave-button{
  background-color: #ea7f1d;
}
.margin {
    padding-bottom: 20px;
}

</style>